(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  var elem = document.querySelector('.home-hero-carousel');
var flkty = new Flickity( elem, {
  // options
  cellAlign: 'center',
  wrapAround: true,
  autoPlay: true,
  prevNextButtons: false,
  pageDots: false,
  pauseAutoPlayOnHover: false
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  var reviewsCarousel = document.querySelector('.reviews-carousel');
var reviewsCarouselFlkty = new Flickity( reviewsCarousel, {
  // options
  cellAlign: 'left',
  wrapAround: true,
  autoPlay: true,
  adaptiveHeight: true,
  pageDots: false,
  prevNextButtons: false,
  pauseAutoPlayOnHover: false,
  watchCSS: true
});
  // Assign custom buttons
// var prevButton2 = document.querySelector('.custom-prev-button-2');
// var nextButton2 = document.querySelector('.custom-next-button-2');

// Add event listeners to custom buttons
// prevButton2.addEventListener('click', function () {
//   reviewsCarouselFlkty.previous(); // Go to the previous slide
// });

// nextButton2.addEventListener('click', function () {
//   reviewsCarouselFlkty.next(); // Go to the next slide
// });
document.addEventListener("DOMContentLoaded", function () {
  var readMoreTexts = document.querySelectorAll('.review-link');

  // Add click event listener for review links
  readMoreTexts.forEach((readMoreText) => {
    readMoreText.addEventListener('click', function () {
      // Resize the carousel
      reviewsCarouselFlkty.resize();

      // Find the parent .carousel-cell
      var carouselCell = readMoreText.closest('.carousel-cell');

      if (carouselCell) {
        // Remove the .active class from all .carousel-cell elements
        document.querySelectorAll('.carousel-cell').forEach((cell) => {
          cell.classList.remove('active');
        });

        // Add the .active class to the clicked .carousel-cell
        carouselCell.classList.add('active');

        // Get the index of the .carousel-cell
        var index = Array.from(carouselCell.parentNode.children).indexOf(carouselCell);

        // Use Flickity to select the cell
        reviewsCarouselFlkty.select(index);
      }
    });
  });

  // Listen for Flickity's change event
  reviewsCarouselFlkty.on('change', function (index) {
    // Remove the .active class from all .carousel-cell elements
    document.querySelectorAll('.carousel-cell').forEach((cell) => {
      cell.classList.remove('active');
    });

    // Add the .active class to the newly selected cell
    // var activeCell = reviewsCarouselFlkty.cells[index].element;
    // activeCell.classList.add('active');
  });
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-carousel"] && !Shopify.designMode) return;
  try {
    
  var testimonialsCarousel = document.querySelector('.testimonials-carousel-wrap');
var testimonialsCarouselFlkty = new Flickity( testimonialsCarousel, {
  // options
  cellAlign: 'center',
  wrapAround: true,
  autoPlay: true,
  pauseAutoPlayOnHover: false,
  pageDots: false,
  imagesLoaded: true,
  prevNextButtons: false,
  pauseAutoPlayOnHover: false
});

  // Assign custom buttons
var prevButton = document.querySelector('.custom-prev-button');
var nextButton = document.querySelector('.custom-next-button');

// Add event listeners to custom buttons
prevButton.addEventListener('click', function () {
  testimonialsCarouselFlkty.previous(); // Go to the previous slide
});

nextButton.addEventListener('click', function () {
  testimonialsCarouselFlkty.next(); // Go to the next slide
});

  } catch(e) { console.error(e); }
})();
})();
